import React from 'react';
import styles from './SystemsOverview.module.css';
import { findSensorValue } from '../../utils/sensorHelpers';
import { formatMinutes } from '../../utils/dateUtils';
import { useTranslation } from 'react-i18next';
import BatteryCharging60Icon from '@material-ui/icons/BatteryCharging60';
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

function MetricsBar({ metrics, timeSinceLastReading }) {
  const { t } = useTranslation();

  return (
    <div className={styles.infoContainer}>
      <div className={styles.soc}>
        <p className={styles.socText}>{findSensorValue(metrics, 'SOC', '%')}</p>
        <BatteryCharging60Icon />
      </div>
      <div className={styles.current}>
        <p className={styles.currentText}>
          {findSensorValue(metrics, 'Power', 'A')}
        </p>
        <OfflineBoltIcon />
      </div>
      {timeSinceLastReading !== Infinity && (
        <div className={styles.timeSinceLastData}>
          <p className={styles.timeSinceLastDataText}>
            {formatMinutes(timeSinceLastReading, t('h'))}
          </p>
          <AccessTimeIcon />
        </div>
      )}
    </div>
  );
}

export default MetricsBar;
